export default __webpack_public_path__ + "static/media/cluster.25111a8c.svg";